<template>
	<div class="box content">
		<div class="is-flex is-flex-apart">
			<h2>{{ heading }}</h2>

			<Dropdown
				:options="roster_positions"
				:optionText="(option) => option.position"
				:handleSelectedOption="setSelectedRosterPosition"
			/>
		</div>

		<table class="table is-fullwidth is-hidden-mobile">
			<thead>
				<tr>
					<th class="has-text-right">#</th>
					<th>Player</th>
					<th class="has-text-centered" v-if="selectedRosterPosition.show_position">Position</th>
					<th class="has-text-right">Points</th>
					<th class="has-text-centered">Week</th>
					<th>Team</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(data, index) in selectedRosterPositionPlayers">
					<td class="has-text-right">{{ index + 1 }}</td>
					<td>{{ data.player.name }}</td>
					<td class="has-text-centered" v-if="selectedRosterPosition.show_position">{{ data.player.display_position }}</td>
					<td class="has-text-right">{{ data.points }}</td>
					<td class="has-text-centered">{{ data.week }}</td>
					<td><TeamLink :teamKey="data.team.key" :teamName="data.team.name" /></td>
				</tr>
			</tbody>
		</table>

		<table class="table is-fullwidth is-hidden-tablet">
			<tbody>
				<tr v-for="(data, index) in selectedRosterPositionPlayers">
					<td class="has-text-right">{{ index + 1 }}</td>
					<td>{{ data.player.name }}</td>
					<td class="has-text-centered" v-if="selectedRosterPosition.show_position">{{ data.player.display_position }}</td>
					<td>Wk&nbsp;{{ data.week }}</td>
					<td class="has-text-right">{{ data.points }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Dropdown from "./Dropdown"
import TeamLink from "./TeamLink"

export default {
	props: ["heading", "roster_positions", "players_key"],
	components: {
		Dropdown,
		TeamLink,
	},
	data() {
		return {
			selectedRosterPositionIndex: 0,
		}
	},
	computed: {
		selectedRosterPosition() {
			return (this.roster_positions && this.roster_positions[this.selectedRosterPositionIndex]) || null
		},
		selectedRosterPositionPlayers() {
			return this.selectedRosterPosition ? this.selectedRosterPosition[this.players_key] : []
		},
	},
	methods: {
		setSelectedRosterPosition(index) {
			this.selectedRosterPositionIndex = index
		},
	},
}
</script>

<style scoped></style>
